// src/expensescategories.js
import React from 'react';

const ExpensesCategories = ({
  styles,
  parents,
  categories,
  parentsById,
  buildCategoryLabel,
  showAddParent,
  setShowAddParent,
  showAddCategory,
  setShowAddCategory,
  showManageCats,
  setShowManageCats,
  newParentName,
  setNewParentName,
  newCategoryName,
  setNewCategoryName,
  newCategoryParentId,
  setNewCategoryParentId,
  addParent,
  addCategory,
  editParentId,
  setEditParentId,
  editParentName,
  setEditParentName,
  editCatId,
  setEditCatId,
  editCatName,
  setEditCatName,
  editCatParentId,
  setEditCatParentId,
  startEditParent,
  saveEditParent,
  startEditCategory,
  saveEditCategory,
  deleteParent,
  deleteCategory
}) => {
  return (
    <>
      {/* ADD PARENT MODAL */}
      {showAddParent && (
        <div style={styles.modalOverlay} onClick={() => setShowAddParent(false)}>
          <div style={styles.modal} onClick={(ev) => ev.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>ADD PARENT GROUP</div>
              <button style={styles.btnDanger} onClick={() => setShowAddParent(false)}>CLOSE</button>
            </div>

            <label style={styles.label}>PARENT NAME</label>
            <input
              style={styles.input}
              value={newParentName}
              onChange={(e) => setNewParentName(e.target.value)}
              placeholder="E.G. VEHICLE / OFFICE / SUPPLIES"
            />

            <div style={styles.btnRow}>
              <button style={styles.btnBlack} onClick={addParent}>SAVE PARENT</button>
              <button style={styles.btnLight} onClick={() => setShowAddParent(false)}>CANCEL</button>
            </div>
          </div>
        </div>
      )}

      {/* ADD CATEGORY MODAL */}
      {showAddCategory && (
        <div style={styles.modalOverlay} onClick={() => setShowAddCategory(false)}>
          <div style={styles.modal} onClick={(ev) => ev.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>ADD CATEGORY</div>
              <button style={styles.btnDanger} onClick={() => setShowAddCategory(false)}>CLOSE</button>
            </div>

            <label style={styles.label}>PARENT (REQUIRED)</label>
            <select style={styles.input} value={newCategoryParentId} onChange={(e) => setNewCategoryParentId(e.target.value)}>
              <option value="">SELECT PARENT</option>
              {(parents || []).map((p) => (
                <option key={p.id} value={p.id}>{p.name}</option>
              ))}
            </select>

            <div style={{ height: '10px' }} />

            <label style={styles.label}>CATEGORY NAME</label>
            <input
              style={styles.input}
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              placeholder="E.G. FUEL / TOOLS / PRINTING"
            />

            <div style={styles.btnRow}>
              <button style={styles.btnBlack} onClick={addCategory}>SAVE CATEGORY</button>
              <button style={styles.btnLight} onClick={() => setShowAddCategory(false)}>CANCEL</button>
            </div>
          </div>
        </div>
      )}

      {/* MANAGE MODAL (EDIT + DELETE) */}
      {showManageCats && (
        <div style={styles.modalOverlay} onClick={() => setShowManageCats(false)}>
          <div style={styles.modal} onClick={(ev) => ev.stopPropagation()}>
            <div style={styles.modalHeader}>
              <div>MANAGE: PARENTS & CATEGORIES</div>
              <button style={styles.btnDanger} onClick={() => setShowManageCats(false)}>CLOSE</button>
            </div>

            <div style={styles.smallRow}>
              {/* PARENTS */}
              <div>
                <div style={{ fontWeight: 900, textTransform: 'uppercase', marginBottom: '10px' }}>PARENTS</div>

                {editParentId ? (
                  <div style={{ border: '6px solid black', padding: '12px', marginBottom: '12px', fontWeight: 900 }}>
                    <div style={{ marginBottom: '8px' }}>EDIT PARENT</div>
                    <input style={styles.input} value={editParentName} onChange={(e) => setEditParentName(e.target.value)} />
                    <div style={styles.btnRow}>
                      <button style={styles.btnBlack} onClick={saveEditParent}>SAVE</button>
                      <button
                        style={styles.btnLight}
                        onClick={() => {
                          setEditParentId('');
                          setEditParentName('');
                        }}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                ) : null}

                {(parents || []).length === 0 ? (
                  <div style={{ fontWeight: 900 }}>No parents yet.</div>
                ) : (
                  (parents || []).map((p) => (
                    <div
                      key={p.id}
                      style={{
                        border: '4px solid black',
                        padding: '10px',
                        marginBottom: '10px',
                        fontWeight: 900,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap'
                      }}
                    >
                      <div>{p.name}</div>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button
                          style={styles.tinyBtnLight}
                          onClick={() => startEditParent(p)}
                        >
                          EDIT
                        </button>
                        <button style={styles.tinyBtn} onClick={() => deleteParent(p.id)}>DELETE</button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {/* CATEGORIES */}
              <div>
                <div style={{ fontWeight: 900, textTransform: 'uppercase', marginBottom: '10px' }}>CATEGORIES</div>

                {editCatId ? (
                  <div style={{ border: '6px solid black', padding: '12px', marginBottom: '12px', fontWeight: 900 }}>
                    <div style={{ marginBottom: '8px' }}>EDIT CATEGORY</div>

                    <label style={styles.label}>PARENT</label>
                    <select style={styles.input} value={editCatParentId} onChange={(e) => setEditCatParentId(e.target.value)}>
                      <option value="">SELECT PARENT</option>
                      {(parents || []).map((p) => (
                        <option key={p.id} value={p.id}>{p.name}</option>
                      ))}
                    </select>

                    <div style={{ height: '10px' }} />

                    <label style={styles.label}>CATEGORY NAME</label>
                    <input style={styles.input} value={editCatName} onChange={(e) => setEditCatName(e.target.value)} />

                    <div style={styles.btnRow}>
                      <button style={styles.btnBlack} onClick={saveEditCategory}>SAVE</button>
                      <button
                        style={styles.btnLight}
                        onClick={() => {
                          setEditCatId('');
                          setEditCatName('');
                          setEditCatParentId('');
                        }}
                      >
                        CANCEL
                      </button>
                    </div>
                  </div>
                ) : null}

                {(categories || []).length === 0 ? (
                  <div style={{ fontWeight: 900 }}>No categories yet.</div>
                ) : (
                  (categories || []).map((c) => (
                    <div
                      key={c.id}
                      style={{
                        border: '4px solid black',
                        padding: '10px',
                        marginBottom: '10px',
                        fontWeight: 900,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: '10px',
                        flexWrap: 'wrap'
                      }}
                    >
                      <div>{buildCategoryLabel(c, parentsById)}</div>
                      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                        <button
                          style={styles.tinyBtnLight}
                          onClick={() => startEditCategory(c)}
                        >
                          EDIT
                        </button>
                        <button style={styles.tinyBtn} onClick={() => deleteCategory(c.id)}>DELETE</button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>

            <div style={{ marginTop: '10px', fontWeight: 900 }}>
              NOTE: Deleting a parent also deletes its categories.
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExpensesCategories;
